module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showScheduleBlock) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('schedule', {
    staticClass: "pb-0",
    attrs: {
      "date": _vm.date,
      "schedule": _vm.homepage,
      "appointment": _vm.currentAppointment,
      "loading": _vm.scheduleRequest.loading
    },
    on: {
      "today": function($event) {
        return _vm.gotoToday()
      },
      "previous": function($event) {
        return _vm.changeDate(-1)
      },
      "next": function($event) {
        return _vm.changeDate(1)
      },
      "previous:week": function($event) {
        return _vm.changeDate(-7)
      },
      "next:week": function($event) {
        return _vm.changeDate(7)
      },
      "date": _vm.setDate,
      "selected": _vm.setCurrentAppointment,
      "close": function($event) {
        _vm.listSpaceIndex = 0
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$vuetify.breakpoint.xs) ? _c('v-flex', {
    staticClass: "hidden-xs",
    attrs: {
      "xs12": "",
      "sm12": !_vm.showScheduleBlock,
      "sm7": _vm.showScheduleBlock,
      "md7": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-2",
    attrs: {
      "dense": ""
    }
  }, [(_vm.$vuetify.breakpoint.xl) ? [_c('v-toolbar-side-icon', [_c('v-icon', {
    attrs: {
      "color": "amber"
    }
  }, [_vm._v("flash_on")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/calendar"
    }
  }, [_vm._v("Calendar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/clients"
    }
  }, [_vm._v("Clients")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/invoices"
    }
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/reports"
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('birthday-bar')], 2), _vm._v(" "), _c('home-detail', {
    staticClass: "mt-2",
    attrs: {
      "homepage": _vm.homepage,
      "appointment": _vm.currentAppointment,
      "loading": _vm.scheduleRequest.loading
    },
    on: {
      "close": function($event) {
        _vm.currentAppointment = null
      },
      "chart:appointments:clicked": _vm.chartClicked
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0aa649","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Home.vue
// module id = 1475
// module chunks = 9